import React from 'react';

const Button = ({ text, onClick, secondary = false, className = '' }) => {
  return (
    <button
      onClick={onClick}
      className={`px-6 py-3 rounded-md font-medium transition-colors duration-300 ${
        secondary 
          ? 'border-2 border-primary text-primary hover:bg-primary hover:text-white'
          : 'bg-primary text-white hover:bg-primaryHover'
      } ${className}`}
    >
      {text}
    </button>
  );
};

export default Button;